(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let rocketKidsCartLabelObserver;
  let rocketKidsObservedCartButton;
  function syncRocketKidsCartLabel() {
    const button = rocketKidsObservedCartButton;
    if (!button) return;
    const label = Array.from(button.querySelectorAll('.visually-hidden'))
      .map(element => element.textContent.trim())
      .filter(Boolean)
      .join(' ');
    if (label && button.getAttribute('aria-label') !== label) {
      button.setAttribute('aria-label', label);
    }
  }
  function initRocketKidsCartLabel() {
    const button = document.getElementById('cart-icon-bubble');
    if (!button) return;
    if (button !== rocketKidsObservedCartButton) {
      if (rocketKidsCartLabelObserver) rocketKidsCartLabelObserver.disconnect();
      rocketKidsObservedCartButton = button;
      rocketKidsCartLabelObserver = new MutationObserver(syncRocketKidsCartLabel);
      rocketKidsCartLabelObserver.observe(button, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    syncRocketKidsCartLabel();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRocketKidsCartLabel, { once: true });
  } else {
    initRocketKidsCartLabel();
  }
  document.addEventListener('shopify:section:load', initRocketKidsCartLabel);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-animated-heading"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-letter-heading')) {
    customElements.define('rk-letter-heading', class extends HTMLElement {
      connectedCallback() {
        this.flights = [];
        this.abort = new AbortController();
        this.ready = false;
        this.played = false;
        this.heading = this.querySelector('h2');
        this.video = this.closest('.shopify-section')?.previousElementSibling?.querySelector('video');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.heading || this.motion.matches || !Element.prototype.animate) return;
        this.querySelectorAll('.rk-letter-line').forEach(line => {
          const content = line.textContent;
          line.textContent = '';
          Array.from(content).forEach(letter => {
            const span = document.createElement('span');
            span.className = 'rk-letter-char';
            span.textContent = letter;
            line.appendChild(span);
          });
        });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.tryStart();
        }, { threshold: 1 });
        this.observer.observe(this.heading);
        this.video?.addEventListener('timeupdate', () => this.tryStart(), { signal: this.abort.signal });
        window.addEventListener('resize', () => this.finish(), { signal: this.abort.signal });
        this.motion.addEventListener('change', () => this.finish(), { signal: this.abort.signal });
        document.fonts.ready.then(() => {
          if (!this.isConnected) return;
          this.ready = true;
          this.tryStart();
          this.fallback = setTimeout(() => { this.timedOut = true; this.tryStart(); }, 6500);
        });
      }
      tryStart() {
        if (!this.ready || !this.visible || this.played || this.motion.matches) return;
        if (this.video && !this.video.paused && this.video.currentTime < 1.8 && !this.timedOut) return;
        this.played = true;
        this.dataset.animation = 'playing';
        this.observer?.disconnect();
        clearTimeout(this.fallback);
        const titleBox = this.heading.getBoundingClientRect();
        const box = this.video?.getBoundingClientRect();
        const source = box && box.bottom > 0 ? box : titleBox;
        const style = getComputedStyle(this.heading);
        const colors = ['#e94339', '#e5aa18', '#37a34a', '#2466bb'];
        const chars = Array.from(this.querySelectorAll('.rk-letter-char')).filter(el => el.textContent.trim());
        chars.forEach((el, i) => {
          const target = el.getBoundingClientRect();
          const clone = document.createElement('span');
          clone.className = 'rk-letter-fly';
          clone.setAttribute('aria-hidden', 'true');
          clone.textContent = el.textContent;
          Object.assign(clone.style, {
            left: target.left + 'px', top: target.top + 'px',
            fontFamily: style.fontFamily, fontSize: style.fontSize,
            fontWeight: style.fontWeight, fontStyle: style.fontStyle,
            color: style.color
          });
          document.body.appendChild(clone);
          const x = source.left + source.width * (0.25 + (i % 9) * 0.06) - target.left;
          const sourceY = Math.max(12, Math.min(source.bottom - 30, source.top + source.height * 0.55));
          const y = sourceY - target.top;
          el.style.visibility = 'hidden';
          const animation = clone.animate([
            { transform: 'translate(' + x + 'px,' + y + 'px) rotate(' + ((i % 2 ? 1 : -1) * 25) + 'deg) scale(0.8)', opacity: 0, color: colors[i % 4], offset: 0 },
            { transform: 'translate(' + (x + 12) + 'px,' + (y - 18) + 'px) rotate(-12deg)', opacity: 1, color: colors[i % 4], offset: 0.23 },
            { transform: 'translate(0,-6px) rotate(0deg)', opacity: 1, color: style.color, offset: 0.86 },
            { transform: 'translate(0,0) rotate(0deg)', opacity: 1, color: style.color, offset: 1 }
          ], { duration: 2450, delay: i * 40, easing: 'cubic-bezier(.22,.65,.3,1)', fill: 'both' });
          this.flights.push({ animation, clone, el });
          animation.finished.then(() => {
            el.style.visibility = '';
            clone.remove();
          }).catch(() => {});
        });
        this.cleanup = setTimeout(() => this.finish(), 2550 + chars.length * 40);
      }
      finish() {
        clearTimeout(this.cleanup);
        this.flights?.forEach(({ animation, clone, el }) => {
          el.style.visibility = '';
          animation.cancel();
          clone.remove();
        });
        this.flights = [];
        if (this.played) this.dataset.animation = 'complete';
      }
      disconnectedCallback() {
        this.finish();
        clearTimeout(this.fallback);
        this.observer?.disconnect();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
